/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
'use strict';

var getCorrectDocumentFromNode = require("./getCorrectDocumentFromNode");

var getSelectionOffsetKeyForNode = require("./getSelectionOffsetKeyForNode");
/**
 * Get the key from the node's nearest offset-aware ancestor.
 */


function findAncestorOffsetKey(node) {
  var searchNode = node;

  while (searchNode && searchNode !== getCorrectDocumentFromNode(node).documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);

    if (key != null) {
      return key;
    }

    searchNode = searchNode.parentNode;
  }

  return null;
}

module.exports = findAncestorOffsetKey;


/*****************
 ** WEBPACK FOOTER
 ** ./~/draft-js/lib/findAncestorOffsetKey.js
 ** module id = 163
 ** module chunks = 9
 **/